import { Component, computed, inject } from '@angular/core';
import { AppStore } from '@app/stores/app/app.store';

@Component({
    selector: 'app-content-header',
    templateUrl: './content-header.component.html',
    styleUrls: ['./content-header.component.scss'],
    imports: [],
})
export class ContentHeaderComponent {
    private appStore = inject(AppStore);
    titlePage = computed(() => this.appStore.titlePage());
    testIdName = computed(() => {
        return this.titlePage().toLowerCase().replace(/ /g, '-');
    });
}
